import {SmallDashboardWrapper, Wrapper} from "./smallDashboard.styles";
import {ButtonComponent} from "../../button/button.component";
import React from "react";
import {Grid} from "../../../theme/styles";
import {NumericFormat} from "react-number-format";

export const SmallDashboardComponent = React.memo(({onOpenChange, setActiveService, balance, toggler, hideBalance = true}: {
    hideBalance?: boolean,
    balance: string | number,
    toggler: () => void,
    onOpenChange: (v: boolean) => void,
    setActiveService: React.Dispatch<React.SetStateAction<string | null>>
}) => {
    return <Wrapper>
        <SmallDashboardWrapper>
            <div className="balanceSect">
                <div className={"title"}>
                    <h6 className={"total-balance !mb-0"}>Total Balance</h6>
                    <div onClick={toggler} className={"icon-btn"}>
                        {
                            !hideBalance ?
                                <svg viewBox="0 0 24 24" fill="currentColor"
                                     xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M9.46998 15.2799C9.27998 15.2799 9.08998 15.2099 8.93998 15.0599C8.11998 14.2399 7.66998 13.1499 7.66998 11.9999C7.66998 9.60992 9.60998 7.66992 12 7.66992C13.15 7.66992 14.24 8.11992 15.06 8.93992C15.2 9.07992 15.28 9.26992 15.28 9.46992C15.28 9.66992 15.2 9.85992 15.06 9.99992L9.99998 15.0599C9.84998 15.2099 9.65998 15.2799 9.46998 15.2799ZM12 9.16992C10.44 9.16992 9.16998 10.4399 9.16998 11.9999C9.16998 12.4999 9.29998 12.9799 9.53998 13.3999L13.4 9.53992C12.98 9.29992 12.5 9.16992 12 9.16992Z"
                                    />
                                    <path
                                        d="M5.60003 18.51C5.43003 18.51 5.25003 18.45 5.11003 18.33C4.04003 17.42 3.08003 16.3 2.26003 15C1.20003 13.35 1.20003 10.66 2.26003 8.99998C4.70003 5.17998 8.25003 2.97998 12 2.97998C14.2 2.97998 16.37 3.73998 18.27 5.16998C18.6 5.41998 18.67 5.88998 18.42 6.21998C18.17 6.54998 17.7 6.61998 17.37 6.36998C15.73 5.12998 13.87 4.47998 12 4.47998C8.77003 4.47998 5.68003 6.41998 3.52003 9.80998C2.77003 10.98 2.77003 13.02 3.52003 14.19C4.27003 15.36 5.13003 16.37 6.08003 17.19C6.39003 17.46 6.43003 17.93 6.16003 18.25C6.02003 18.42 5.81003 18.51 5.60003 18.51Z"
                                    />
                                    <path
                                        d="M12 21.02C10.67 21.02 9.37 20.75 8.12 20.22C7.74 20.06 7.56 19.62 7.72 19.24C7.88 18.86 8.32 18.68 8.7 18.84C9.76 19.29 10.87 19.52 11.99 19.52C15.22 19.52 18.31 17.58 20.47 14.19C21.22 13.02 21.22 10.98 20.47 9.81C20.16 9.32 19.82 8.85 19.46 8.41C19.2 8.09 19.25 7.62 19.57 7.35C19.89 7.09 20.36 7.13 20.63 7.46C21.02 7.94 21.4 8.46 21.74 9C22.8 10.65 22.8 13.34 21.74 15C19.3 18.82 15.75 21.02 12 21.02Z"
                                    />
                                    <path
                                        d="M12.69 16.2699C12.34 16.2699 12.02 16.0199 11.95 15.6599C11.87 15.2499 12.14 14.8599 12.55 14.7899C13.65 14.5899 14.57 13.6699 14.77 12.5699C14.85 12.1599 15.24 11.8999 15.65 11.9699C16.06 12.0499 16.33 12.4399 16.25 12.8499C15.93 14.5799 14.55 15.9499 12.83 16.2699C12.78 16.2599 12.74 16.2699 12.69 16.2699Z"
                                    />
                                    <path
                                        d="M2 22.7502C1.81 22.7502 1.62 22.6802 1.47 22.5302C1.18 22.2402 1.18 21.7602 1.47 21.4702L8.94 14.0002C9.23 13.7102 9.71 13.7102 10 14.0002C10.29 14.2902 10.29 14.7702 10 15.0602L2.53 22.5302C2.38 22.6802 2.19 22.7502 2 22.7502Z"
                                    />
                                    <path
                                        d="M14.53 10.2199C14.34 10.2199 14.15 10.1499 14 9.99994C13.71 9.70994 13.71 9.22994 14 8.93994L21.47 1.46994C21.76 1.17994 22.24 1.17994 22.53 1.46994C22.82 1.75994 22.82 2.23994 22.53 2.52994L15.06 9.99994C14.91 10.1499 14.72 10.2199 14.53 10.2199Z"
                                    />
                                </svg>
                                :
                                <svg viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M11.9999 16.33C9.60992 16.33 7.66992 14.39 7.66992 12C7.66992 9.61004 9.60992 7.67004 11.9999 7.67004C14.3899 7.67004 16.3299 9.61004 16.3299 12C16.3299 14.39 14.3899 16.33 11.9999 16.33ZM11.9999 9.17004C10.4399 9.17004 9.16992 10.44 9.16992 12C9.16992 13.56 10.4399 14.83 11.9999 14.83C13.5599 14.83 14.8299 13.56 14.8299 12C14.8299 10.44 13.5599 9.17004 11.9999 9.17004Z"
                                    />
                                    <path
                                        d="M12.0001 21.02C8.24008 21.02 4.69008 18.82 2.25008 15C1.19008 13.35 1.19008 10.66 2.25008 8.99998C4.70008 5.17998 8.25008 2.97998 12.0001 2.97998C15.7501 2.97998 19.3001 5.17998 21.7401 8.99998C22.8001 10.65 22.8001 13.34 21.7401 15C19.3001 18.82 15.7501 21.02 12.0001 21.02ZM12.0001 4.47998C8.77008 4.47998 5.68008 6.41998 3.52008 9.80998C2.77008 10.98 2.77008 13.02 3.52008 14.19C5.68008 17.58 8.77008 19.52 12.0001 19.52C15.2301 19.52 18.3201 17.58 20.4801 14.19C21.2301 13.02 21.2301 10.98 20.4801 9.80998C18.3201 6.41998 15.2301 4.47998 12.0001 4.47998Z"
                                    />
                                </svg>
                        }

                    </div>
                </div>
                <div className={"balance"}>
                    <h1>
                        {hideBalance ? "****" :
                            <NumericFormat
                                value={balance}
                                displayType="text"
                                thousandSeparator=","
                                decimalScale={2}
                                fixedDecimalScale
                                prefix="₦"/>
                        }
                    </h1>
                </div>
            </div>
            <div className={"actions"}>
                <ButtonComponent onClick={() => {
                    setActiveService("FundWallet")
                    onOpenChange(true)
                }} $color={"#3900BD"} $bgColor={"#FFFFFF"} size={"base"} icon={
                    <svg style={{width: "1em", fontSize: "18px"}} viewBox="0 0 24 24" fill="none"
                         xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M12 22C17.5 22 22 17.5 22 12C22 6.5 17.5 2 12 2C6.5 2 2 6.5 2 12C2 17.5 6.5 22 12 22Z"
                            stroke="#3900BD" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M8 12H16" stroke="#3900BD" stroke-width="1.5" stroke-linecap="round"
                              stroke-linejoin="round"/>
                        <path d="M12 16V8" stroke="#3900BD" stroke-width="1.5" stroke-linecap="round"
                              stroke-linejoin="round"/>
                    </svg>
                }>Add Money</ButtonComponent>
                <ButtonComponent onClick={() => {
                    setActiveService("Transfer")
                    onOpenChange(true)
                }} $color={"#3900BD"} $bgColor={"#FFFFFF"} size={"base"} icon={
                    <svg style={{width: "1em", fontSize: "18px"}} viewBox="0 0 20 20" fill="none"
                         xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M6.16689 5.26667L13.2419 2.90833C16.4169 1.85 18.1419 3.58333 17.0919 6.75833L14.7336 13.8333C13.1502 18.5917 10.5502 18.5917 8.96689 13.8333L8.26689 11.7333L6.16689 11.0333C1.40856 9.45 1.40856 6.85833 6.16689 5.26667Z"
                            stroke="#3900BD" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M8.4248 11.375L11.4081 8.38333" stroke="#3900BD" stroke-width="1.25"
                              stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                }>Transfer</ButtonComponent>
            </div>
        </SmallDashboardWrapper>
        <Grid $columns={"repeat(2, minmax(0, 1fr))"} className={"md:mt-3 mt-4 dashboard-action"}>
            <ButtonComponent $type={"outlined"} className={"outline-tablet"} onClick={() => {
                setActiveService("FundWallet")
                onOpenChange(true)
            }} fullWidth={true} size={"base"} icon={
                <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M12 22C17.5 22 22 17.5 22 12C22 6.5 17.5 2 12 2C6.5 2 2 6.5 2 12C2 17.5 6.5 22 12 22Z"
                        stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M8 12H16" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"
                          stroke-linejoin="round"/>
                    <path d="M12 16V8" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"
                          stroke-linejoin="round"/>
                </svg>
            }>Add Money</ButtonComponent>
            <ButtonComponent onClick={() => {
                setActiveService("Transfer")
                onOpenChange(true)
            }} fullWidth={true} $type={"outlined"} size={"base"} icon={
                <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M6.16689 5.26667L13.2419 2.90833C16.4169 1.85 18.1419 3.58333 17.0919 6.75833L14.7336 13.8333C13.1502 18.5917 10.5502 18.5917 8.96689 13.8333L8.26689 11.7333L6.16689 11.0333C1.40856 9.45 1.40856 6.85833 6.16689 5.26667Z"
                        stroke="currentColor" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M8.4248 11.375L11.4081 8.38333" stroke="currentColor" stroke-width="1.25"
                          stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
            }>Transfer</ButtonComponent>
        </Grid>
    </Wrapper>
})